namespace Cfnc {
    "use strict";

    interface ITranscriptSchoolScope extends ng.IScope {
        vm: TranscriptSchool;
    }

    interface ITranscriptSchool {
    }

    class TranscriptSchool implements ITranscriptSchool {
        static controllerId: string = "transcriptSchool";
        static $inject: Array<string> = ["config", "$location", "common", "Restangular", "$scope", "$uibModal", "$http", "helper"];
        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        loaded: boolean;
        pageNumber: number;
        totalSchools: number;
        startRow: number;
        endRow: number;
        schoolList: any;
        searchString: any;
        apiHost: any;

        constructor(private config: IConfig,
            private $location: ng.ILocationService,
            private common: ICommonFactory,
            private Restangular: Restangular.IService,
            private $scope: ITranscriptSchoolScope,
            private $uibModal: ng.ui.bootstrap.IModalService,
            private $http: ng.IHttpService,
            private helper: IHelper) {

            this.log = common.logger.getLogFn(TranscriptSchool.controllerId);
            this.logError = common.logger.getLogFn(TranscriptSchool.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(TranscriptSchool.controllerId, "success");
            this.apiHost = this.config.apiHost;
            this.loaded = false;
            this.pageNumber = 1;
            this.searchString = "";
            
            this.activate();

        }

        activate() {
            var promises = [];
            this.common.activateController(promises, TranscriptSchool.controllerId)
                .then(() => {
                    this.log("Activated E-Transcript School List View");
                    this.getTranscriptSchools("");
                });
        }

        getTranscriptSchools(baseString: string) {
            var params = { pageNumber: this.pageNumber, startsWith: baseString };
            this.Restangular.one("transcripts/getTranscriptSchools").get(params)
                .then((result: any) => {
                    this.loaded = true;
                    this.schoolList = result.schools;
                    this.totalSchools = result.totalSchools;

                    if (result.totalSchools > 0) {
                        this.startRow = this.pageNumber === 1 ? 1 : (25 * (this.pageNumber - 1)) + 1;
                        this.endRow = (this.startRow - 1) + result.schools.length;
                    } else {
                        this.startRow = 0;
                        this.endRow = 0;
                    }

                }, (reason) => {
                    console.log(reason);
                    this.logError("An error occurred while getting the list of schools.", reason, true);
                });
        }

        GetTranscriptSchoolsFile() {
            this.Restangular.one("transcripts/getTranscriptSchoolsExport").get()
                .then((result: any) => {
                }, (reason) => {
                    console.log(reason);
                    this.logError("An error occurred while getting the export.", reason, true);
                });
        }

        checkCleared() {
            if (this.searchString == "")
                this.getTranscriptSchools("");
        }

        openTranscriptModal() {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/transcriptSchools/TranscriptModal.html',
                controller: 'TranscriptModal',
                size: 'lg'
            });
        }

        openFile = (httpPath, data) => {
            this.helper.openFile(httpPath).then(() => { },
                (reason) => {
                    this.logError("An error occurred while saving the file", reason);
                });
        }
    }

    angular.module("app").controller(TranscriptSchool.controllerId, TranscriptSchool);
}